import React from 'react';
import { Card, Container } from 'semantic-ui-react';

const ImageDisplay = (props) => {
    const { result } = props;

    const eachPictures = <>
        {
            result.map(image => (
                <Card key={image.id} image={image.urls.regular} />
            ))
        }
    </>

    const loading = <img src={require('../assets/images/loading.gif')} alt='loading' />

    return (
        <Container textAlign='justified'>
            <Card.Group itemsPerRow={3}>
                {result ? eachPictures : loading}
            </Card.Group>
        </Container>
    )
}

export default ImageDisplay;